import {CFComponentProps} from 'module/CustomField/type/CFComponentType'
import {CFValue} from 'module/CustomField/type/CFType'
import {CF} from 'module/CustomField/util/CustomField'
import {CFAttrKey} from 'module/CustomField/constant/CFAttrConstants'
import React, {useCallback} from 'react'
import {cssCFSlct} from 'module/CustomField/style/cssCFInput'
import {Slct} from 'module/Slct/component/Slct'
import {filterOptionsSlct} from 'module/Slct/util/filterOptionsSlct'
import {getCustomFieldAvailableInputTypes} from 'module/CustomField/util/getCustomFieldAvailableInputTypes'
import {SlctOption} from 'module/Slct/type/SlctType'
import {SetCb} from 'type/SetCb'

export function CustomFieldAvailableInputTypesComponent<ModelType extends object | void, ValueType extends string | number>(props: CFComponentProps<CFValue>) {
	const {
		cfDef,
		pos,
		setCb,
		model,
		modelValue,
		disabled,
		placeholderHTML,
	} = props

	const options = getCustomFieldAvailableInputTypes() as SlctOption<ModelType, ValueType>[]
	const menuWidth = Number(CF.getCFAttr(cfDef, CFAttrKey.menuWidth)?.value)
	const onChange: SetCb<SlctOption<ModelType, ValueType> | null> = useCallback((x) => {
		setCb(x?.value)
	}, [setCb])

	return (
		<div className={'CustomFieldAvailableInputTypesComponent'} css={cssCFSlct}>
			<Slct
				disabled={disabled}
				placeholderHTML={placeholderHTML}
				options={options}
				value={!modelValue && modelValue !== 0 ? null : modelValue}
				onChange={onChange}
				filterOptions={filterOptionsSlct}
				menuWidth={menuWidth}
			/>
		</div>
	)
}